// ADR 3.10.26f §2 — which header doors are pinned, one `prefStore` key per
// device. The key is bare, as the settings stores' are, because the phones
// (3.10.26g) spell it the same way.
//
// `['settings']` is the default so nobody's bar changes on deploy; `[]` is a
// choice, not "unset", and `serialize` never returns `null`, so the key is
// never removed once written. A pin whose entry is absent is skipped when
// drawing, never deleted here.

import { prefStore } from '../../features/settings/prefStore'
import type { SwitcherId } from './entries'

const HEADER_PINS_KEY = 'header_pins'

const KNOWN: readonly SwitcherId[] = ['settings', 'developer', 'connections']
const DEFAULT_PINS: SwitcherId[] = ['settings']

function isSwitcherId(value: unknown): value is SwitcherId {
  return typeof value === 'string' && (KNOWN as readonly string[]).includes(value)
}

/** Never throws: known ids only, no duplicates; absent, non-array or corrupt JSON reads the default. */
function parsePins(raw: string | null): SwitcherId[] {
  if (raw === null) return DEFAULT_PINS
  let value: unknown
  try {
    value = JSON.parse(raw)
  } catch {
    return DEFAULT_PINS
  }
  if (!Array.isArray(value)) return DEFAULT_PINS
  return [...new Set(value.filter(isSwitcherId))]
}

export const headerPins = prefStore<SwitcherId[]>(HEADER_PINS_KEY, parsePins, (pins) => JSON.stringify(pins))
